import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises
import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module';

// Modules metier utilises

// Composants metiers
import { SousParcCheckboxListComponent } from './components/sous-parc-checkbox-list.component';
import { SousParcMultiSelectorComponent } from './components/sous-parc-multi-selector.component';

// Services metier
import { SousParcService } from './services/sous-parc.service';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,

		CheckboxListModule,
		FilterableSelectModule,
	],
	providers: [
		SousParcService,
	],
	declarations: [
		SousParcCheckboxListComponent,
		SousParcMultiSelectorComponent,
	],
	exports: [
		SousParcCheckboxListComponent,
		SousParcMultiSelectorComponent,
	]
})
export class SousParcModule {
	constructor() { }
}

angular.module('auroraApp') //
	.service('a2sousParcService',
		downgradeInjectable(SousParcService)
	) //
;